module.exports = "/packs/media/images/allactions-ed7d55551c109d09cea39dacef3287eb.png";